'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleExitIntent = undefined;

var _executeClientTrigger = require('../../client-triggers/actions/executeClientTrigger');

var handleExitIntent = exports.handleExitIntent = function handleExitIntent() {
  return function (dispatch) {
    dispatch((0, _executeClientTrigger.executeClientTrigger)());
  };
};